"use client";

// Structurally based on (main_app)/lead-gen-profiles/_component/FilterSheet.jsx
// (same pending-selection + Apply/Clear flow, same useContractorFiltersStore),
// but this page's FILTER_CONFIG categories have since diverged from that
// page's per the find-contractors filter PRD — see filterConfig.js.
import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { colorDisabledOnColorDisabled, colorSecondarySecondary } from "@/app/(styles)/variables";
import FilterListIcon from "@mui/icons-material/FilterList";
import { EMPTY_SELECTED, FILTER_CONFIG } from "./filterConfig";
import { FilterSection } from "./FilterOptions";
import { useContractorFiltersStore } from "@/store/store";
import PageViewTracker from "../../../_components/global/PageViewTracker";
import { inhomzEvents } from "../../../_lib/events";
import { useInhomzTrack } from "../../../_hooks/useInhomzTrack";
import { buildFilterEventProps } from "../_utils/buildFilterEventProps";
const FilterSheet = t0 => {
  const $ = _c(33);
  const {
    onClose
  } = t0;
  const track = useInhomzTrack();
  const {
    appliedFilters,
    setAppliedFilters,
    clearFilters: clearStoreFilters
  } = useContractorFiltersStore();
  let t1;
  if ($[0] !== appliedFilters?.selected) {
    t1 = () => ({
      selected: {
        ...EMPTY_SELECTED,
        ...(appliedFilters?.selected || {})
      }
    });
    $[0] = appliedFilters?.selected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [pendingFilters, setPendingFilters] = useState(t1);
  let t2;
  if ($[2] !== pendingFilters.selected || $[3] !== track) {
    t2 = (category, value) => {
      track(inhomzEvents.contractorFilters.OPTION_TOGGLED, {
        source: "sheet",
        category,
        event_value: value,
        selected: !pendingFilters.selected[category].includes(value)
      });
      setPendingFilters(prev => {
        const isCurrentlySelected = prev.selected[category].includes(value);
        const isSelecting = !isCurrentlySelected;
        return {
          ...prev,
          selected: {
            ...prev.selected,
            [category]: isSelecting ? [...prev.selected[category], value] : prev.selected[category].filter(v => v !== value)
          }
        };
      });
    };
    $[2] = pendingFilters.selected;
    $[3] = track;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleFilter = t2;
  let t3;
  if ($[5] !== clearStoreFilters || $[6] !== onClose || $[7] !== track) {
    t3 = () => {
      track(inhomzEvents.contractorFilters.CLEAR_CLICKED, {
        source: "sheet"
      });
      const clearedFilters = {
        selected: EMPTY_SELECTED
      };
      setPendingFilters(clearedFilters);
      clearStoreFilters();
      onClose();
    };
    $[5] = clearStoreFilters;
    $[6] = onClose;
    $[7] = track;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleClearFilters = t3;
  let t4;
  if ($[9] !== onClose || $[10] !== pendingFilters || $[11] !== setAppliedFilters || $[12] !== track) {
    t4 = () => {
      track(inhomzEvents.contractorFilters.APPLY_CLICKED, {
        source: "sheet",
        ...buildFilterEventProps(pendingFilters.selected)
      });
      setAppliedFilters(pendingFilters);
      onClose();
    };
    $[9] = onClose;
    $[10] = pendingFilters;
    $[11] = setAppliedFilters;
    $[12] = track;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleApplyFilters = t4;
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Object.entries(FILTER_CONFIG);
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== pendingFilters.selected) {
    t6 = t5.map(t7 => {
      const [category_0, config] = t7;
      return {
        title: config.title,
        options: config.options,
        category: category_0,
        selectedValues: pendingFilters.selected[category_0] || []
      };
    });
    $[15] = pendingFilters.selected;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const filterSections = t6;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PageViewTracker event={inhomzEvents.contractorFilters.VIEWED} properties={{
      source: "sheet"
    }} />;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      borderBottomColor: colorDisabledOnColorDisabled,
      borderBottomWidth: "1px"
    };
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="px-[16px] pt-[16px] pb-[12px] border-b flex-shrink-0" style={t8}><div className="flex items-center gap-2"><div className="w-[32px] h-[32px] flex items-center justify-center md:hidden"><FilterListIcon sx={{
            color: colorSecondarySecondary,
            fontSize: "24px"
          }} /></div><div className="m3-headline-small text-[--textPrimaryPrimary] md:m3-title-small">Filters</div></div></div>;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== filterSections || $[21] !== toggleFilter) {
    t10 = <div className="flex-1 overflow-y-auto min-h-0"><div className="space-y-6 px-4 py-4">{filterSections.map(section => <FilterSection key={section.category} title={section.title} options={section.options} selectedValues={section.selectedValues} category={section.category} toggleFilter={toggleFilter} />)}</div></div>;
    $[20] = filterSections;
    $[21] = toggleFilter;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== handleClearFilters) {
    t11 = <button onClick={handleClearFilters} className="flex-1 py-3 px-4 rounded-full border border-[--colorSecondarySecondary] bg-[--colorSurfaceSurface] text-[--textSecondarySecondary] m3-label-large">Clear filters</button>;
    $[23] = handleClearFilters;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== handleApplyFilters) {
    t12 = <button onClick={handleApplyFilters} className="flex-1 py-3 px-4 rounded-full bg-[--colorPrimaryPrimary] text-[--textPrimaryOnColorPrimary] m3-label-large">Apply filters</button>;
    $[25] = handleApplyFilters;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div className="px-4 py-4 flex-shrink-0 border-t border-[--colorDisabledOnColorDisabled] bg-[--colorSurfaceSurface] flex gap-3">{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t13) {
    t14 = <div className="flex flex-col mx-auto h-[80vh]">{t7}{t9}{t10}{t13}</div>;
    $[30] = t10;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default FilterSheet;